/* ============================================================
   The Money–Body Code — lazy-bg.js
   Loads below-the-fold background photos (.rbg-lazy, see
   snippets/bg-photo.liquid) shortly before they scroll into view,
   so the first photo on the page doesn't share the connection with
   every other photo further down.

   Re-scans on shopify:section:load so sections re-rendered in the
   theme editor still show their photos.
   ============================================================ */
(function () {
  function reveal(el) { el.classList.remove('rbg-lazy'); }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      }, { rootMargin: '150% 0px' })
    : null;

  function watch(root) {
    root.querySelectorAll('.rbg-lazy').forEach(function (el) {
      if (io) io.observe(el); else reveal(el);
    });
  }

  watch(document);
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
})();
